// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TablePagination_pagination__2fiwA {\n  border-top: 1px solid var(--border-table);\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Table/TablePagination.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;AAC3C","sourcesContent":[".pagination {\n  border-top: 1px solid var(--border-table);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination": "TablePagination_pagination__2fiwA"
};
export default ___CSS_LOADER_EXPORT___;
